"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importStar(require("react"));

var root_1 = require("./styled/root");

var getElementProps = function getElementProps(_a) {
  var href = _a.href,
      onClick = _a.onClick,
      isDisabled = _a.isDisabled,
      rest = tslib_1.__rest(_a, ["href", "onClick", "isDisabled"]);

  var isButton = !href && onClick;

  if (isDisabled || isButton) {
    return tslib_1.__assign({
      as: 'button',
      role: 'link',
      onClick: onClick,
      disabled: isDisabled,
      'aria-disabled': isDisabled
    }, rest);
  }

  return tslib_1.__assign({
    as: 'a',
    href: href
  }, rest);
};
/**
 * A Link is a navigational element that takes the user to another view.
 * @returns
 */


var Link = (0, react_1.forwardRef)(function (_a, ref) {
  var __UIScope = _a.__UIScope,
      className = _a.className,
      label = _a.label,
      _b = _a.pattern,
      pattern = _b === void 0 ? 'primary' : _b,
      _c = _a.isInverse,
      isInverse = _c === void 0 ? false : _c,
      leadingIcon = _a.leadingIcon,
      trailingIcon = _a.trailingIcon,
      _d = _a.scale,
      scale = _d === void 0 ? 5 : _d,
      href = _a.href,
      onClick = _a.onClick,
      _e = _a.isDisabled,
      isDisabled = _e === void 0 ? false : _e,
      _f = _a.hasUnderline,
      hasUnderline = _f === void 0 ? false : _f,
      rest = tslib_1.__rest(_a, ["__UIScope", "className", "label", "pattern", "isInverse", "leadingIcon", "trailingIcon", "scale", "href", "onClick", "isDisabled", "hasUnderline"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Link',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var polymorphicProps = getElementProps(tslib_1.__assign({
    href: href,
    onClick: onClick,
    isDisabled: isDisabled
  }, rest));
  var iconScale = Math.max(1, Math.floor(scale / 2));
  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    className: rootClasses
  }, polymorphicProps, {
    pattern: isInverse ? 'inverse' : pattern,
    hasUnderline: hasUnderline,
    ref: ref
  }), leadingIcon ? react_1.default.createElement(ui_icon_1.Icon, {
    name: leadingIcon,
    scale: iconScale,
    "aria-hidden": true,
    mr: 1
  }) : null, react_1.default.createElement(ui_text_1.Text, {
    scale: scale
  }, label), trailingIcon ? react_1.default.createElement(ui_icon_1.Icon, {
    name: trailingIcon,
    scale: iconScale,
    "aria-hidden": true,
    ml: 1
  }) : null);
});
Link.displayName = 'Link';
var LinkWithSpace = (0, ui_helper_with_space_1.withSpace)(Link);
exports.Link = LinkWithSpace;